module.exports = __webpack_public_path__ + "static/media/sugar-blood-level.c52c66ce.svg";